import React, { useState, createContext, useContext, useCallback } from 'react';

/**
 * @typedef SessionExpiredPopup
 * @property {boolean} open
 */

/**
 * @typedef {Object} Popups
 * @property {SessionExpiredPopup} SessionExpiredPopup
 */

/**
 * Returns the object that maps to the popups
 * @returns {[Popups, function]}
 */
const usePopups = () => {
    return useContext(PopupContext);
};
const PopupContext = createContext(null);

const PopupContextProvider = ({ children }) => {
    const [popups, setPopups] = useState({
        sessionExpiredPopup: {
            open: false,
        }
    });
    const open = useCallback((popup, props) => {
        setPopups(prev => ({
            ...prev,
            [popup]: {
                ...(props || {}),
                open: true,
            }
        }));
    }, [setPopups]);

    const close = useCallback((popup) => {
        setPopups(prev => ({
            ...prev,
            [popup]: {
                ...(prev[popup] || {}),
                open: false,
            }
        }));
    }, [setPopups]);
    return (
        <PopupContext.Provider value={[popups, open, close, setPopups]}>
            {children}
        </PopupContext.Provider>
    );
};

export default PopupContextProvider;
export { usePopups };